import { fbt } from 'fbtee'
import type { UserProfile } from '../types'
import { UserRow } from './UserRow'
import { Button } from './ui/button'

/** An incoming friend request with labeled Accept / Decline buttons. */
export function FriendRequestRow({
  loading,
  name,
  profile,
  onOpen,
  onAccept,
  onDecline,
}: {
  loading?: boolean
  name?: string
  profile?: UserProfile
  onOpen?: () => void
  onAccept?: () => void
  onDecline?: () => void
}) {
  if (loading) return <UserRow loading />
  return (
    <UserRow
      name={name}
      profile={profile}
      onClick={onOpen}
      subtitle={fbt('Wants to be your friend', 'Subtitle on an incoming friend request row')}
      action={
        <div className="flex items-center gap-1.5">
          <Button size="sm" className="h-8" onClick={onAccept} data-testid="friend-request-accept">
            {fbt('Accept', 'Button to accept an incoming friend request')}
          </Button>
          <Button size="sm" variant="outline" className="h-8" onClick={onDecline}>
            {fbt('Decline', 'Button to decline an incoming friend request')}
          </Button>
        </div>
      }
    />
  )
}
